import { Token } from "interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const tokenApi = coreApi.injectEndpoints({
  endpoints: builder => ({
    checkToken: builder.query<Token, string>({
      query: token => ({
        url: "Token/CheckToken",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
})

export const { useLazyCheckTokenQuery } = tokenApi
